import {React,useState} from 'react'
import {
    Icon,
    IconButton,
    Button,
    Menu,
    MenuItem,
    Tooltip,
  } from '@mui/material';
  import { MoreVert } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';


const MenuActions = ( {actions=[],obj}) => {
    const dispatch = useDispatch();
    const [anchorEl,setAnchorEl] = useState();
  const openActionMenu= Boolean(anchorEl);
  
  const setAnchorElement = (e)=>{
    setAnchorEl(e.currentTarget);
  }

    const {handleClick,pathFunction,allowActions,getRoute,closeDialog,closeViewOrderDialog,onSelect} = obj;

  /**
   * PGSS-5453 — this menu now carries the popup actions that did not fit inline, so picking one
   * here has to do what its button would have done. Callers whose buttons run something other than
   * handleClick (the approval buttons open their own dialog) pass `onSelect`; without one the menu
   * keeps its original behaviour.
   *
   * `to_statuses_types_id` is forwarded too. It was dropped before, which did not show while the
   * menu only ever held the tail of an action list nobody could reach.
   */
  const runAction = (action) => {
    setAnchorEl(null);
    if (onSelect) {
      onSelect(action);
      return;
    }
    dispatch(closeViewOrderDialog());
    handleClick(action.ui_id, action.to_statuses_types_code, action.name, action.to_statuses_types_id);
  };

    return(
    <>
      <Tooltip title="more actions">
        <IconButton onClick={(e)=>setAnchorElement(e)}>
          <MoreVert/>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={openActionMenu}
        onClose={()=>{setAnchorEl(null)}} 
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'bottom',
        }}
    >
        {actions.map((action)=>{
          const { name, icon, ui_id: uiId } = action;
          return (
          <MenuItem
                key={uiId}
                onClick={() => runAction(action)}
                component={pathFunction(uiId) && allowActions.includes(uiId) ? Link : undefined}
                to={getRoute(pathFunction(uiId), uiId)}>
          <IconButton
                className="py-0 px-2"
                size="small"
                
              >
                <Icon fontSize="small">{icon}</Icon>
            </IconButton>
            <span style={{ fontSize: 12 }}>{name}</span>
          </MenuItem>
          );
        })}
      </Menu>
    </>
    )
}

export default MenuActions